import { captureClientDetailSelection, ownsClientDetailSelection } from "store/slices/clientDetailOwnership";
import React, { useLayoutEffect, useState } from "react";
import { useSelector, useDispatch, useStore } from "react-redux";
import { useTranslation } from "react-i18next";
import config from "../../../config";
import Appointment from "./Appointment";
import ClientEditForm from "../Form/ClientEditForm";
import Voucher from "./Voucher";
import Subscription from "./Subscription";
import ClientSubscriptionIndicator from "./ClientSubscriptionIndicator";
import Membership from "./Membership";
import Products from "./Products"
import Photos from "./Photos";
import Invoices from "./Invoices";
import Documents from "./Documents";
import Notes from "./Notes";
import Forms from "./Forms"
import { CloseClientDetailModal, ClientDetailApi, ClientDetailTab, ClientGridViewApi, ClientListViewApi, ClientDataToSale, SetClientAppointmentCalendar } from "../../../store/slices/clientSlice";
import { ucfirst, usercheckAccess } from "../../../helpers/Functions";
import { ClientphotoGridViewApi } from "store/slices/clientphotoSlice";
import { ClientdocumentGridViewApi } from "store/slices/clientdocumentSlice";
import { ClientnoteGridViewApi } from "store/slices/clientnoteSlice";
import { ClientAppointmentListViewApi, clientAppointmentFilterStatus, openAppointmentFilter } from "store/slices/appointmentSlice";
import { ClientMembershipListViewApi } from "store/slices/clientmembershipSlice";
import { ClientInvoiceListViewApi, OpenClientInvoiceDetails, OpenClientInvoiceRefundModal, OpenPartialPaidInvoice, OpenStripeRefundCompletedSaleModal } from "store/slices/clientinvoiceSlice";
import { ClientVoucherListViewApi } from "store/slices/clientvoucherSlice";
import { ClientchatGridViewApi } from "store/slices/clientChatSlice";
import { openAddSaleForm, SaleTabView } from "store/slices/saleSlice";
import { useNavigate } from "react-router";
import { ClientproductApi } from "store/slices/clientproductSlice";
import { clientDetailAppointmentPrintApi } from "store/slices/printerSlice";
import ChatMessages from "./ChatMessages";
import { OpenClientRefundSelection, OpenRefundInvoice, openPastInvoiceDrawer } from "store/slices/clientappointmentinvoiceSlice";
import { ClientSubscriptionListViewApi } from "store/slices/clientsubscriptionSlice";
import { ClientformApi } from "store/slices/clientformSlice";
import { appointmentContact, clientDetailId, normalizeClientDetail, readableClientHistoryError } from "./clientDetailUx";
import ParentChildProfiles from "./ParentChildProfiles";
import AuthenticatedClientPhoto from "./Photos/AuthenticatedClientPhoto";
import { getClientAppointmentFilterOptions } from "./clientAppointmentFilter";
import ClientPaymentMethods from "./clientPaymentMethods";
import WalletCard from "./WalletCard";
import getStripeClient from "pages/getStripeClient";
import Elements from "pages/SalonStripeElements";
import { buildClientAppointmentPrintRequest, getPdfDownloadDescriptor } from "./clientAppointmentPrintUx";

const ClientDetailModal = () => {
  const [loading, setLoading] = useState(false);
  const [printError, setPrintError] = useState("");
  const rightDrawerOpened = useSelector((state) => state.client.isOpenedDetailModal);
  const detailTab = useSelector((state) => state.client.isClientDetailTab);
  const detail = normalizeClientDetail(useSelector((state) => state.client.isDetailData));
  const auth = useSelector((state) => state.auth);
  const currentUser = auth && auth.user;
  const stripePromise = getStripeClient();
  const navigate = useNavigate();
  void (currentUser && currentUser.role_id);
  const access = useSelector((state) => state.salonmodule.isAccess);
  const isFilter = useSelector((state) => state.appointment.isClientAppointmentFilterStatus);
  const dispatch = useDispatch();
  const store = useStore();
  const detailSelection = captureClientDetailSelection(store.getState().client);
  const { t } = useTranslation();
  const resolvedAppointmentContact = appointmentContact(detail);
  let emailid = resolvedAppointmentContact.email || "";
  void (currentUser && currentUser.useraccess);
  const hasAccess = usercheckAccess("client_detail_view", currentUser);
  const canCreateChild = usercheckAccess("clients.create", currentUser);
  const canUpdateRelationship = usercheckAccess("clients.update", currentUser);
  const client_id = clientDetailId(detail);

  const handleCloseClientDetailModal = () => {
    //dispatch({ type: "client/detail/rejected" });
    dispatch(CloseClientDetailModal(true));
    setTimeout(() => {
      dispatch(CloseClientDetailModal(""));
    }, config.modalCloseTimeOut);
  };
  const handlePrintClientAppointments = async (event) => {
    event?.preventDefault();
    setPrintError("");
    setLoading(true);
    const action = await dispatch(clientDetailAppointmentPrintApi(
      buildClientAppointmentPrintRequest(client_id, new Date(), currentUser?.salon?.timezone),
    ));
    setLoading(false);
    if (action.meta.requestStatus !== "fulfilled") {
      setPrintError(readableClientHistoryError(action.payload, "Unable to print client appointments."));
      return;
    }
    const descriptor = getPdfDownloadDescriptor(action.payload);
    if (!descriptor) {
      setPrintError("The appointment PDF was empty.");
      return;
    }
    const anchor = document.createElement("a");
    anchor.href = descriptor.href;
    anchor.download = "client-appointments.pdf";
    anchor.target = "_blank";
    anchor.rel = "noopener noreferrer";
    anchor.click();
    if (descriptor.revoke && typeof URL !== "undefined" && URL.revokeObjectURL) {
      window.setTimeout(() => URL.revokeObjectURL(descriptor.href), 60_000);
    }
  };
  const first_name = detail.first_name || "";
  const last_name = detail.last_name || "";
  const email = detail.email || "";
  // let phone_number = detail.phone_number;
  const profile_photo_url = detail.profile_photo_url;
  const profile_photo_id = detail.profile_photo_id;
  const filterOption = getClientAppointmentFilterOptions(t);


  useLayoutEffect(() => {
    if (!client_id) return;
    if(detailTab == ""){
      dispatch(ClientDetailTab("clientdetail"))
    }
    if (detailTab == "appointment") {
      dispatch(ClientAppointmentListViewApi({ client_id: client_id, filter:isFilter, page_name: "client_appointment" }));
    }
    if (detailTab == "photos") {
      dispatch(ClientphotoGridViewApi({ client_id: client_id }));
    }
    if (detailTab == "invoices") {
      dispatch(ClientInvoiceListViewApi({ client_id: client_id, category: "completed" }));
    }
    if (detailTab == "documents") {
      dispatch(ClientdocumentGridViewApi({ client_id: client_id }));
    }
    if (detailTab == "notes") {
      dispatch(ClientnoteGridViewApi({ client_id: client_id }));
    }
    if (detailTab == "memberships") {
      dispatch(ClientMembershipListViewApi({ client_id: client_id }));
    }
    if (detailTab == "vouchers") {
      dispatch(ClientVoucherListViewApi({ client_id: client_id }));
    }
    if (detailTab == "forms") {
      dispatch(ClientformApi({ client_id: client_id }));
    }
    if (detailTab == "chatmessages") {
      dispatch(ClientchatGridViewApi({ client_id: client_id }));
    }
    if (detailTab == "subscriptions") {
      dispatch(ClientSubscriptionListViewApi({ client_id: client_id }));
    }
    if (detailTab == "products") {
      dispatch(ClientproductApi({ client_id: client_id }));
    }
  }, [detailTab, client_id, isFilter, dispatch])

  if (!client_id) return null;


  return (
    <React.Fragment>
      <div className={"drawer client-detaildrawer p-0 overflow-y-client-detail-auto " + rightDrawerOpened}>
        <div className="drawer-wrp">
          <a className="close-drawer cursor-pointer" onClick={handleCloseClientDetailModal}>
            <img src={config.imagepath + "close-icon.svg"} alt="" />
          </a>
          <div className="drawer-body row">
            <div className="left-menu col-md-5">
              <div className="d-flex mb-3 align-items-baseline">
                {profile_photo_url ? (
                  <div className="user col-2 me-2">
                    {profile_photo_id ? (
                      <AuthenticatedClientPhoto photo={{ id: profile_photo_id, revision: profile_photo_url }} className="profile-image-obj rounded-circle wh-40" link />
                    ) : (
                      <a data-fancybox="" data-src={profile_photo_url}>
                        <img src={profile_photo_url} alt="" className="profile-image-obj rounded-circle wh-40" />
                      </a>
                    )}
                  </div>
                ) : (
                  <div className="user-initial me-md-3 me-2 p-md-3 client-user-circles custom-client-user-circles-lh">{first_name.charAt(0) + "" + last_name.charAt(0)}</div>
                )}
                <div className="user-id">
                  <h3 className="user-name mb-0">{ucfirst(first_name + " " + last_name)}</h3>
                  <span className="user-id overflow-wrap-anywhere">{email}</span>
                </div>
              </div>
              <div className="row gx-2 action-box mb-3 align-items-end">
                <a className="col text-center text-decoration-none" onClick={() => {
                  dispatch(CloseClientDetailModal(""));
                  dispatch(SetClientAppointmentCalendar(detail));
                  navigate(config.basePath + "/calendar");
                }}>
                  <img src={config.imagepath + "appoinment.png"} alt="" />
                  <span className="d-block">{t("Appointment")}</span>
                </a>
                <a href="#" className="col text-center text-decoration-none" onClick={() => {
                  dispatch(CloseClientDetailModal(""));
                  dispatch({ type: "sale/reset" });
                  dispatch(openAddSaleForm());
                  dispatch(ClientDataToSale(detail));
                }}>
                  <img src={config.imagepath + "sale-light.png"} alt="" />
                  <span className="d-block">{t("Sale")}</span>
                </a>
                <a href={`mailto:${emailid}`} target="_blank" className="col text-center text-decoration-none">
                  <img src={config.imagepath + "email.png"} alt="" />
                  <span className="d-block">{t("Email")}</span>
                </a>
                <a className="col text-center text-decoration-none" onClick={()=>{
                  dispatch(ClientDetailTab("chatmessages"));
                }}>
                  <img src={config.imagepath + "sms.png"} alt="" />
                  <span className="d-block">{t("SMS")}</span>
                </a>
              </div>
              <ul className="nav flex-md-column nav-pills mb-0 list-unstyled" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className={"nav-link" + (detailTab && detailTab == "appointment" ? " active" : "")}
                    id="appoinment"
                    data-bs-toggle="tab"
                    data-bs-target="#appoinment-tab"
                    type="button"
                    role="tab"
                    onClick={() => {
                      //Invoicerefunds Close
                      dispatch(OpenClientInvoiceDetails(""));
                      dispatch(openPastInvoiceDrawer(""));
                      dispatch(OpenRefundInvoice(""));
                      dispatch(OpenPartialPaidInvoice(""));
                      dispatch(OpenStripeRefundCompletedSaleModal(""));
                      dispatch(OpenClientInvoiceRefundModal(""));
                      dispatch(OpenClientRefundSelection(""));
                      //Invoicerefunds Close
                      dispatch(ClientDetailTab("appointment"));
                    }}
                  >
                    {t("Appointments")}
                  </button>
                </li>
                {hasAccess && (
                  <li className="nav-item" role="presentation">
                    <button className={"nav-link" + (detailTab && detailTab == "clientdetail" ? " active" : "")} id="client-detail" data-bs-toggle="tab" data-bs-target="#client-detail-tab" type="button" role="tab" onClick={() => dispatch(ClientDetailTab("clientdetail"))}>
                      {t("Client Details")}
                    </button>
                  </li>
                )}
                {hasAccess && (
                  <li className="nav-item" role="presentation">
                    <button className={"nav-link" + (detailTab && detailTab == "paymentmethods" ? " active" : "")} id="payment-methods" data-bs-toggle="tab" data-bs-target="#payment-methods-tab" type="button" role="tab" onClick={() => dispatch(ClientDetailTab("paymentmethods"))}>
                      {t("Saved cards")}
                    </button>
                  </li>
                )}
                <li className="nav-item" role="presentation">
                  <button className={"nav-link" + (detailTab && detailTab == "wallet" ? " active" : "")} id="wallet" data-bs-toggle="tab" data-bs-target="#wallet-tab" type="button" role="tab" onClick={() => dispatch(ClientDetailTab("wallet"))}>
                    {t("Wallet")}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={"nav-link" + (detailTab && detailTab == "vouchers" ? " active" : "")}
                    id="vouchers"
                    data-bs-toggle="tab"
                    data-bs-target="#vouchers-tab"
                    type="button"
                    role="tab"
                    onClick={() => {
                      dispatch(ClientDetailTab("vouchers"));
                    }}
                  >
                    {t("Vouchers")}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button className={"nav-link" + (detailTab && detailTab == "subscriptions" ? " active" : "")} id="subscriptions" data-bs-toggle="tab" data-bs-target="#subscriptions-tab" type="button" role="tab" onClick={() => dispatch(ClientDetailTab("subscriptions"))}>
                    <span className="d-flex align-items-center justify-content-between">
                    {t("Subscriptions")}
                    <ClientSubscriptionIndicator status={detail?.subscription_payment_status} legacyIcon={detail?.isClientSubscriptionPlan} />
                    </span>
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={"nav-link" + (detailTab && detailTab == "memberships" ? " active" : "")}
                    id="memberships"
                    data-bs-toggle="tab"
                    data-bs-target="#memberships-tab"
                    type="button"
                    role="tab"
                    onClick={() => {
                      dispatch(ClientDetailTab("memberships"));
                    }}
                  >
                    {t("Packages")}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={"nav-link" + (detailTab && detailTab == "products" ? " active" : "")}
                    id="products"
                    data-bs-toggle="tab"
                    data-bs-target="#products-tab"
                    type="button"
                    role="tab"
                    onClick={() => {
                      dispatch(ClientDetailTab("products"));
                    }}
                  >
                    {t("Products")}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={"nav-link" + (detailTab && detailTab == "photos" ? " active" : "")}
                    id="photos"
                    data-bs-toggle="tab"
                    data-bs-target="#photos-tab"
                    type="button"
                    role="tab"
                    onClick={() => {
                      dispatch(ClientDetailTab("photos"));
                    }}
                  >
                    {t("Photos")}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={"nav-link" + (detailTab && detailTab == "invoices" ? " active" : "")}
                    id="invoices"
                    data-bs-toggle="tab"
                    data-bs-target="#invoices-tab"
                    type="button"
                    role="tab"
                    onClick={() => {
                      //Invoicerefunds Close
                      dispatch(OpenClientInvoiceDetails(""));
                      dispatch(openPastInvoiceDrawer(""));
                      dispatch(OpenRefundInvoice(""));
                      dispatch(OpenPartialPaidInvoice(""));
                      dispatch(OpenStripeRefundCompletedSaleModal(""));
                      dispatch(OpenClientInvoiceRefundModal(""));
                      dispatch(OpenClientRefundSelection(""));
                      //Invoicerefunds Close
                      dispatch(ClientDetailTab("invoices"));
                    }}
                  >
                    {t("Invoices")}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={"nav-link" + (detailTab && detailTab == "documents" ? " active" : "")}
                    id="documents"
                    data-bs-toggle="tab"
                    data-bs-target="#documents-tab"
                    type="button"
                    role="tab"
                    onClick={() => {
                      dispatch(ClientDetailTab("documents"));
                    }}
                  >
                    {t("Documents")}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={"nav-link" + (detailTab && detailTab == "notes" ? " active" : "")}
                    id="notes"
                    data-bs-toggle="tab"
                    data-bs-target="#notes-tab"
                    type="button"
                    role="tab"
                    onClick={() => {
                      dispatch(ClientDetailTab("notes"));
                    }}
                  >
                    {t("Notes")}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={"nav-link" + (detailTab && detailTab == "forms" ? " active" : "")}
                    id="forms"
                    data-bs-toggle="tab"
                    data-bs-target="#forms-tab"
                    type="button"
                    role="tab"
                    onClick={() => {
                      dispatch(ClientDetailTab("forms"));
                    }}
                  >
                    {t("Forms")}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={"nav-link" + (detailTab && detailTab == "chatmessages" ? " active" : "")}
                    id="chat-msg"
                    data-bs-toggle="tab"
                    data-bs-target="#chat-msg-tab"
                    type="button"
                    role="tab"
                    onClick={() => {
                      dispatch(ClientDetailTab("chatmessages"));
                    }}
                  >
                    {t("Messages")}
                  </button>
                </li>
              </ul>
            </div>
            <div className={`content col-md-7 position-relative ${detailTab && detailTab == "chatmessages" ? "p-0" : ""}`}>
              <div className="tab-content" id="myTabContent">
                <div className={"tab-pane fade" + (detailTab && detailTab == "appointment" ? " show active" : "")} id="appoinment-tab" role="tabpanel" aria-labelledby="appoinment-tab">
                  <div className="drawer-header">
                    <h2 className="mb-4 pe-md-5">
                      {t("Appointments")} <span className="cursor-pointer" onClick={handlePrintClientAppointments} aria-busy={loading} aria-label={t("Print appointments")}><img src={config.imagepath + "print.png"} alt={t("Print appointments")} className="ms-md-2 ms-1" /></span>
                    </h2>
                    {printError && <div className="alert alert-danger" role="alert">{printError}</div>}
                    <div className="row justify-content-end">
                      <div className="col-12 mb-4">
                        <div className="w-50">
                        <select
                          className="form-control"
                          onChange={(e) => {
                            const filter = { status: e.currentTarget.value };
                            dispatch(openAppointmentFilter(filter));
                            dispatch(clientAppointmentFilterStatus(filter));
                          }}
                          value={isFilter && isFilter.status}
                        >
                          {filterOption &&
                            Object.keys(filterOption).map((item, i) => {
                              let value = filterOption[item].value;
                              let label = filterOption[item].label;
                              return (
                                <option value={value} key={item && item.id ? item.id : i}>
                                  {label}
                                </option>
                              );
                            })}
                        </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  {detailTab && detailTab == "appointment" && <Appointment role_id={currentUser} access={access} />}
                </div>
                {hasAccess && (
                <div className={"tab-pane fade" + (detailTab && detailTab == "clientdetail" ? " show active" : "")} id="client-detail-tab" role="tabpanel" aria-labelledby="client-detail-tab">
                    <div className="drawer-header">
                        <h2 className="mb-4 pe-md-5">
                        {t("Edit Client")} <img src={config.imagepath + "print.png"} alt={t("Print appointments")} className="ms-md-2 ms-1 cursor-pointer" aria-busy={loading} onClick={handlePrintClientAppointments} />
                        </h2>
                        {printError && <div className="alert alert-danger" role="alert">{printError}</div>}
                    </div>
                    {detailTab && detailTab == "clientdetail" ? (
                          <div className="content-wrp">
                            <ParentChildProfiles
                              detail={detail}
                              canCreate={canCreateChild}
                              canUpdate={canUpdateRelationship}
                              onChanged={() => {
                                if (!ownsClientDetailSelection(store.getState().client, detailSelection)) return;
                                dispatch(ClientDetailApi({ id: client_id }));
                                dispatch(ClientGridViewApi());
                                dispatch(ClientListViewApi());
                              }}
                            />
                            <ClientEditForm />
                      </div>
                    ) : ""}
                  </div>
                )}
                <div className={"tab-pane fade" + (detailTab && detailTab == "vouchers" ? " show active" : "")} id="vouchers-tab" role="tabpanel" aria-labelledby="vouchers-tab">
                  <div className="drawer-header">
                    <h2 className="mb-4 pe-md-5 mb-lg-5">
                      {t("Vouchers")}
                      <a href="#" className="btn btn-outline-primary btn-sm ms-2" onClick={() => {
                        dispatch(CloseClientDetailModal(""));
                        dispatch({ type: "sale/reset" });
                        dispatch(openAddSaleForm());
                        dispatch(SaleTabView("vouchers"));
                        dispatch(ClientDataToSale(detail));
                      }}>
                        {t("Sell Gift Voucher")}
                      </a>
                    </h2>
                  </div>
                  {detailTab && detailTab == "vouchers" && <Voucher role_id={currentUser} access={access} />}
                </div>
                <div className={"tab-pane fade" + (detailTab && detailTab == "paymentmethods" ? " show active" : "")} id="payment-methods-tab" role="tabpanel" aria-labelledby="payment-methods-tab">
                  {detailTab && detailTab == "paymentmethods" && (
                    <Elements stripe={stripePromise}>
                      <ClientPaymentMethods clientId={client_id} />
                    </Elements>
                  )}
                </div>
                <div className={"tab-pane fade" + (detailTab && detailTab == "wallet" ? " show active" : "")} id="wallet-tab" role="tabpanel" aria-labelledby="wallet">
                  {detailTab && detailTab == "wallet" && <WalletCard clientId={client_id} currency={currentUser?.salon?.currency || "AUD"} />}
                </div>
                <div className={"tab-pane fade" + (detailTab && detailTab == "subscriptions" ? " show active" : "")} id="subscriptions-tab" role="tabpanel" aria-labelledby="subscriptions-tab">
                  <div className="drawer-header">
                    <h2 className="mb-4 pe-md-5 mb-lg-5">{t("Subscriptions")}</h2>
                  </div>
                  {detailTab && detailTab == "subscriptions" && <Subscription role_id={currentUser} access={access} />}
                </div>
                <div className={"tab-pane fade" + (detailTab && detailTab == "memberships" ? " show active" : "")} id="memberships-tab" role="tabpanel" aria-labelledby="memberships-tab">
                  {detailTab && detailTab == "memberships" && <Membership role_id={currentUser} access={access} />}
                </div>
                <div className={"tab-pane fade" + (detailTab && detailTab == "products" ? " show active" : "")} id="products-tab" role="tabpanel" aria-labelledby="products-tab">
                  {detailTab && detailTab == "products" && <Products role_id={currentUser} access={access} />}
                </div>
                <div className={"tab-pane fade" + (detailTab && detailTab == "photos" ? " show active" : "")} id="photos-tab" role="tabpanel" aria-labelledby="photos-tab">
                  {detailTab && detailTab == "photos" && <Photos role_id={currentUser} access={access} />}
                </div>
                <div className={"tab-pane fade" + (detailTab && detailTab == "invoices" ? " show active" : "")} id="invoices-tab" role="tabpanel" aria-labelledby="invoices-tab">
                  {detailTab && detailTab == "invoices" && <Invoices role_id={currentUser} access={access} />}
                </div>
                <div className={"tab-pane fade" + (detailTab && detailTab == "documents" ? " show active" : "")} id="documents-tab" role="tabpanel" aria-labelledby="documents-tab">
                  {detailTab && detailTab == "documents" && <Documents role_id={currentUser} access={access} />}
                </div>
                <div className={"tab-pane fade" + (detailTab && detailTab == "notes" ? " show active" : "")} id="notes-tab" role="tabpanel" aria-labelledby="notes-tab">
                  {detailTab && detailTab == "notes" && <Notes role_id={currentUser} access={access} />}
                </div>
                <div className={"tab-pane fade" + (detailTab && detailTab == "forms" ? " show active" : "")} id="forms-tab" role="tabpanel" aria-labelledby="forms-tab">
                  {detailTab && detailTab == "forms" && <Forms role_id={currentUser} access={access} />}
                </div>
                <div className={"tab-pane fade p-0 m-0 " + (detailTab && detailTab == "chatmessages" ? " show active" : "")} id="chat-msg-tab" role="tabpanel" aria-labelledby="chat-msg-tab">
                  {detailTab && detailTab == "chatmessages" && <ChatMessages role_id={currentUser} access={access} />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ClientDetailModal;
